import { Link } from 'react-router';
import clsx from 'clsx';

import { routesConfig } from '../../../../routes.config';

import styles from './styles/hero.module.css';

export default function Hero() {
	return (
		<section className={clsx(styles['hero'])}>
			<div className={clsx(styles['hero__container'])}>
				<h1 className={clsx(styles['hero__title'])}>Glass2Melt</h1>
				<p className={clsx(styles['hero__description'])}>
					Explore high-pressure refractive index and density datasets
					for silicate, carbonate, oxide, and halogenated glasses and
					crystalline materials. Filter by class, compound, and
					reference—visualize results or download the data for
					research.
				</p>
				<Link
					className={clsx(styles['hero_cte-button'])}
					to={`/${routesConfig.propertyViewer.path}`}
					aria-label="Discover data in the Property Viewer"
				>
					Discover
				</Link>
			</div>
		</section>
	);
}
